import { IGuestPayloadFilter } from '../pages/guestUser/guestInterface';
import { get } from './apiService';

export const getAllGuestList = async (data: IGuestPayloadFilter) => {
  return await get(`/facility/${data.facilityId}/check-in/users`, data);
};
